module.exports = __webpack_public_path__ + "static/media/Superior.14.b5d342fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/superior/images/Superior.14.jpg
// module id = 691
// module chunks = 0